import { Injectable } from '@angular/core';
import  moment from 'moment';
import { Api } from './api.service';
import { BaseService } from './base.service';

@Injectable()
export class DriverService extends BaseService {

  controllerName = 'api/user';

  constructor(protected api: Api) {
    super(api, 'api/user');
  }

  getDropdown(name: string) {
    return this.api.get(`${this.controllerName}/search/${name}`);
  }

  getAllDrivers() {
    return this.api.get('api/driver/all');
  }

  getListDriverRoute(startDate: moment.Moment, endDate: moment.Moment, routeIds: number[]) {
    const params: any = {
      startDate: startDate.format('L'), // MM/dd/yyyy
      endDate: endDate.format('L'), // MM/dd/yyyy
      routeIds: routeIds
    };
    return this.api.get(`api/driver/get-drivers`, params);
  }

  checkAssignedToRoute(id: number): any {
    return this.api.get(`${this.controllerName}/check-assigned-to-route/${id}`);
  }
  


}
